import React from 'react';

/** Avisos en páginas marketing (el offset del header lo aplica `MarketingLayout` en `#main-scroll`). */
export default function MarketingPageAlerts({ children, className = '' }) {
  if (!children) return null;
  return (
    <div
      className={`relative z-10 w-full max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-2 pb-2 ${className}`}
    >
      {children}
    </div>
  );
}
